'use strict';exports.__esModule = true;var getDecimal = function getDecimal(num) {
  var str = num.toString();
  var zeroPos = str.indexOf('.');
  if (zeroPos === -1) return 0;
  str = str.slice(zeroPos);
  return +str;
};exports.default =

getDecimal;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/getDecimal.js
// module id = 3110
// module chunks = 0